import styled from 'styled-components';
import { PipaHeroBannerProps } from './index';

export const StylesPipeHeroBanner = styled.div<PipaHeroBannerProps>`
  box-sizing: border-box;
  border-radius: 7px;
  background: var(--bundle-border-color);
  max-width: 400px;
  padding: 1px;
  margin: 6px 16px 0 16px;
  width: calc(100% - 32px);

  .image {
    background: ${({ backgroundImg }: any) => `url("${backgroundImg}")`};
    background-size: cover;
    background-position: center;
    width: 100%;
    height: auto;
    padding-top: 33%;
    border-radius: 6px;
  }
`;
